import { render, staticRenderFns } from "./SuppliersEdit.vue?vue&type=template&id=1b63eabe&"
import script from "./SuppliersEdit.vue?vue&type=script&lang=js&"
export * from "./SuppliersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports